import { render, staticRenderFns } from "./TicketManage.vue?vue&type=template&id=d585f646&scoped=true&"
import script from "./TicketManage.vue?vue&type=script&lang=js&"
export * from "./TicketManage.vue?vue&type=script&lang=js&"
import style0 from "./TicketManage.vue?vue&type=style&index=0&id=d585f646&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d585f646",
  null
  
)

export default component.exports